import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pb-5" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import {uploadURL} from "@/model/api";
import {useToast} from "primevue/usetoast";
import {addAttachments, attachments} from "@/model/store";
import FileListItem from "@/components/FileListItem.vue";
import {locStr} from "@/model/localizations";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToast()

const onUpload = (event: any) => {
  const xhr: XMLHttpRequest = event.xhr
  const error = addAttachments(xhr)
  if (error) {
    toast.add({severity: 'error', summary: locStr.value.attachments.toast.uploadingError, detail: `${error}`, life: 10000})
  } else {
    toast.add({severity: 'info', summary: locStr.value.attachments.toast.success, detail: locStr.value.attachments.toast.uploadedMessage(event.files.length), life: 3000})
  }
  console.log(event.files)
}
const errorHandler = (event: any) => {
  const xhr: XMLHttpRequest = event.xhr
  console.log(xhr)
  if (xhr.readyState === 4 && xhr.status === 0) {
    // Unknown network error
    toast.add({severity: 'error', summary: locStr.value.attachments.toast.errorTitle, detail: locStr.value.attachments.toast.networkError, life: 10000})
    return
  }
  toast.add({severity: 'error', summary: locStr.value.attachments.toast.errorTitle, detail: `${xhr.status}: ${xhr.response}`, life: 10000})
}


return (_ctx: any,_cache: any) => {
  const _component_FileUpload = _resolveComponent("FileUpload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(attachments).length)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_unref(locStr).attachments.noAttachments), 1))
        : (_openBlock(), _createElementBlock("h4", _hoisted_3, _toDisplayString(_unref(locStr).attachments.uploadedFiles), 1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachments), (file) => {
        return (_openBlock(), _createBlock(FileListItem, {
          key: file.path,
          file: file
        }, null, 8, ["file"]))
      }), 128))
    ]),
    _createVNode(_component_FileUpload, {
      mode: "basic",
      name: "files",
      url: _unref(uploadURL),
      multiple: true,
      auto: true,
      class: "p-button-secondary",
      "choose-label": _unref(locStr).attachments.addAttachment,
      onUpload: onUpload,
      onError: errorHandler
    }, null, 8, ["url", "choose-label"])
  ], 64))
}
}

})